export const endpoints = {
  UPDATE_MY_PASSWORD: '/api/user/password/change',
  RESET_PASSWORD_REQUEST: '/api/user/password/forgot-request',
  RESET_PASSWORD_VALIDATE: '/api/user/password/forgot-validate',
};
